<template>
    <b-modal :id="modalName" :title="'Showing Batch # ' + row.batch_no" scrollable hide-footer size="xl">
        <b-table-simple hover small responsive bordered sticky-header="calc(100vh - 250px)" id="printMe">
            <b-thead>
                <b-tr>
                    <b-th>Order #</b-th>
                    <b-th>SKU</b-th>
                    <b-th class="text-center">QTY</b-th>
                    <b-th class="text-center">Available</b-th>
                    <b-th>Notes</b-th>
                    <b-th>Category</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(row, index) in finalResult" :key="index">
                    <b-td>{{ row['Order #'] }}</b-td>
                    <b-td>{{ row['SKU'] }}</b-td>
                    <b-td class="text-center">{{ row['QTY'] }}</b-td>
                    <b-td class="text-center">{{ row['Available'] }}</b-td>
                    <b-td>{{ row['Notes'] }}</b-td>
                    <b-td>{{ row['Category'] }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-button type="button" variant="outline-secondary" v-print="'#printMe'">
            <span>Print</span>
        </b-button>

        <b-button type="button" variant="outline-secondary" @click="exportExcel">
            <span>Excel</span>
        </b-button>
    </b-modal>
</template>
<script>
import * as XLSX from 'xlsx/xlsx.mjs';
export default {
    props: ['row'],

    data() {
        return {
            modalName: 'modal-warehousing-batchpicks-show-batch-details',
            finalResult: []
        }
    },

    methods: {
        exportExcel() {
            var invoicesWS = XLSX.utils.json_to_sheet(this.finalResult)

            // A workbook is the name given to an Excel file
            var wb = XLSX.utils.book_new() // make Workbook of Excel

            // add Worksheet to Workbook
            // Workbook contains one or more worksheets
            XLSX.utils.book_append_sheet(wb, invoicesWS, 'Batch list') // invoices list is name of Worksheet

            // export Excel file
            XLSX.writeFile(wb, 'Batch_' + this.row['batch_no'] + '_Export.xlsx')

        },

        getOpenPicks() {
            let url = 'api/warehousing/batchpick/openpicks'
            axios.get(url, {})
                .then((res) => {
                    this.openPicks = res.data.open
                    this.checkAll()
                }, () => {
                    this.has_error = true
                })
        },

        compileFinalResult() {
            // generate final table
            this.row.batch_picks_items.forEach((row) => {
                row.sales_order.sale_order_item.forEach((lineItem) => {
                    this.finalResult.push({
                        'Order #': row.sales_order.sales_order_number,
                        'SKU': lineItem.item.sku,
                        'QTY': lineItem.quantity,
                        'Available': lineItem.item.qty_available,
                        'Notes': lineItem.notes,
                        'Category': lineItem.item.category ? lineItem.item.category.name : ''
                    })
                })
            })

            this.finalResult = _.sortBy(this.finalResult, ['SKU', 'Order #'])
        }
    },

    mounted() {
        this.compileFinalResult()
    }
}
</script>
<style lang="scss">
.modal-content {
    .modal-footer {
        .footer-block {
            text-align: center;
        }
    }
}
</style>
